// extracted by mini-css-extract-plugin
export default {"root":"FooterMiddle_root__YdZc6","item":"FooterMiddle_item__1o-L3","link":"FooterMiddle_link__xN2Hs"};